// eslint-disable-next-line import/prefer-default-export
export const isColor = strColor => {
  const colorStyle = new Option().style;
  colorStyle.color = `#${strColor}`;
  return colorStyle.color !== '';
};
